export const CI_INTEGRATION_CREATE_SUCCESS =
  'CI_INTERGRATION_CREATE_NEW_CI_INTERGRATION_SUCCESSFUL';
export const CI_INTEGRATION_CREATE_FAIL =
  'CI_INTERGRATION_CREATE_NEW_CI_INTERGRATION_UNSUCCESSFUL';
export const CI_INTEGRATION_EDIT_SUCCESS =
  'CI_INTERGRATION_EDIT_CI_INTERGRATION_SUCCESSFUL';
export const CI_INTEGRATION_EDIT_FAIL =
  'CI_INTERGRATION_EDIT_CI_INTERGRATION_UNSUCCESSFUL';
export const CI_INTEGRATION_RECLASSIFY_SUCCESS =
  'CI_INTEGRATION_RECLASSIFY_SUCCESS';
export const CI_INTEGRATION_RECLASSIFY_FAIL = 'CI_INTEGRATION_RECLASSIFY_FAIL';

export const CI_RULE_CREATE_SUCCESS = 'CI_RULE_CREATE_SUCCESS';
export const CI_RULE_CREATE_FAIL = 'CI_RULE_CREATE_FAIL';
export const CI_RULE_EDIT_SUCCESS = 'CI_RULE_EDIT_SUCCESS';
export const CI_RULE_EDIT_FAIL = 'CI_RULE_EDIT_FAIL';
export const CI_RULE_TEST_RULE_SUCCESS = 'CI_RULE_TEST_RULE_SUCCESS';
export const CI_RULE_TEST_RULE_FAIL = 'CI_RULE_TEST_RULE_FAIL';

export const BLUEPRINT_CREATE_SUCCESS = 'BLUEPRINT_CREATE_SUCCESS';
export const BLUEPRINT_EDIT_SUCCESS = 'BLUEPRINT_EDIT_SUCCESS';
export const BLUEPRINT_CREATE_FAIL = 'BLUEPRINT_CREATE_FAIL';
export const BLUEPRINT_EDIT_FAIL = 'BLUEPRINT_EDIT_FAIL';
export const BLUEPRINT_ADD_RESOURCE_SUCCESS = 'BLUEPRINT_ADD_RESOURCE_SUCCESS';
export const BLUEPRINT_ADD_RESOURCE_FAIL = 'BLUEPRINT_ADD_RESOURCE_FAIL';
export const BLUEPRINT_ADD_ONS_RESOURCE_SUCCESS =
  'BLUEPRINT_ADD_ONS_RESOURCE_SUCCESS';
export const BLUEPRINT_ADD_ONS_RESOURCE_FAIL =
  'BLUEPRINT_ADD_ONS_RESOURCE_FAIL';
export const BLUEPRINT_EDIT_RESOURCE_SPEC_SUCCESS =
  'BLUEPRINT_EDIT_RESOURCE_SPEC_SUCCESS';
export const BLUEPRINT_EDIT_RESOURCE_SPEC_FAIL =
  'BLUEPRINT_EDIT_RESOURCE_SPEC_FAIL';
export const BLUEPRINT_EDIT_RESOURCE_BASIC_SUCCESS =
  'BLUEPRINT_EDIT_RESOURCE_BASIC_SUCCESS';
export const BLUEPRINT_EDIT_RESOURCE_BASIC_FAIL =
  'BLUEPRINT_EDIT_RESOURCE_BASIC_FAIL';
export const BLUEPRINT_RESOURCE_DELIVERY_TYPE_CHANGE_SUCCESS =
  'BLUEPRINT_RESOURCE_DELIVERY_TYPE_CHANGE_SUCCESS';
export const BLUEPRINT_RESOURCE_DELIVERY_TYPE_CHANGE_FAIL =
  'BLUEPRINT_RESOURCE_DELIVERY_TYPE_CHANGE_FAIL';

export const ENVIRONMENT_CREATE_SUCCESS = 'ENVIRONMENT_CREATE_SUCCESS';
export const ENVIRONMENT_CREATE_FAIL = 'ENVIRONMENT_CREATE_FAIL';
export const ENVIRONMENT_EDIT_SUCCESS = 'ENVIRONMENT_EDIT_SUCCESS';
export const ENVIRONMENT_EDIT_FAIL = 'ENVIRONMENT_EDIT_FAIL';

export const ENVIRONMENT_DOWNLOAD_CREDENTIALS_SUCCESS =
  'ENVIRONMENT_DOWNLOAD_CREDENTIALS_SUCCESS';
export const ENVIRONMENT_DOWNLOAD_CREDENTIALS_FAIL =
  'ENVIRONMENT_DOWNLOAD_CREDENTIALS_FAIL';
export const ENVIRONMENT_RENEW_CREDENTIALS_SUCCESS =
  'ENVIRONMENT_RENEW_CREDENTIALS_SUCCESS';
export const ENVIRONMENT_RENEW_CREDENTIALS_FAIL =
  'ENVIRONMENT_RENEW_CREDENTIALS_FAIL';
export const DOWNLOAD_VPN_PROFILE_SUCCESS = 'DOWNLOAD_VPN_PROFILE_SUCCESS';
export const DOWNLOAD_VPN_PROFILE_FAIL = 'DOWNLOAD_VPN_PROFILE_FAIL';

export const ENVIRONMENT_LAUNCH_CALL_SUCCESS =
  'ENVIRONMENT_LAUNCH_CALL_SUCCESS';
export const ENVIRONMENT_LAUNCH_CALL_FAIL = 'ENVIRONMENT_LAUNCH_CALL_FAIL';
export const FULL_RELEASE_TRIGGER_SUCCESS = 'FULL_RELEASE_TRIGGER_SUCCESS';
export const FULL_RELEASE_TRIGGER_FAIL = 'FULL_RELEASE_TRIGGER_FAIL';
export const SELECTIVE_RELEASE_TRIGGER_SUCCESS =
  'SELECTIVE_RELEASE_TRIGGER_SUCCESS';
export const SELECTIVE_RELEASE_TRIGGER_FAIL = 'SELECTIVE_RELEASE_TRIGGER_FAIL';
export const CUSTOM_RELEASE_TRIGGER_SUCCESS = 'CUSTOM_RELEASE_TRIGGER_SUCCESS';
export const CUSTOM_RELEASE_TRIGGER_FAIL = 'CUSTOM_RELEASE_TRIGGER_FAIL';
export const FULL_PLAN_RELEASE_TRIGGER_SUCCESS =
  'FULL_PLAN_RELEASE_TRIGGER_SUCCESS';
export const FULL_PLAN_RELEASE_TRIGGER_FAIL = 'FULL_PLAN_RELEASE_TRIGGER_FAIL';
export const FULL_PLAN_ROLLBACK_TRIGGER_SUCCESS =
  'FULL_PLAN_ROLLBACK_TRIGGER_SUCCESS';
export const FULL_PLAN_ROLLBACK_TRIGGER_FAIL =
  'FULL_PLAN_ROLLBACK_TRIGGER_FAIL';
export const SELECTIVE_PLAN_RELEASE_TRIGGER_SUCCESS =
  'SELECTIVE_PLAN_RELEASE_TRIGGER_SUCCESS';
export const SELECTIVE_PLAN_RELEASE_TRIGGER_FAIL =
  'SELECTIVE_PLAN_RELEASE_TRIGGER_FAIL';
export const APPLY_PLANNED_RELEASE_TRIGGER_SUCCESS =
  'APPLY_PLANNED_RELEASE_TRIGGER_SUCCESS';
export const APPLY_PLANNED_RELEASE_TRIGGER_FAIL =
  'APPLY_PLANNED_RELEASE_TRIGGER_FAIL';
export const ENVIRONMENT_SPEC_OVERRIDES_SAVE_SUCCESS =
  'ENVIRONMENT_SPEC_OVERRIDES_SAVE_SUCCESS';
export const ENVIRONMENT_SPEC_OVERRIDES_SAVE_FAIL =
  'ENVIRONMENT_SPEC_OVERRIDES_SAVE_FAIL';

export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_FAIL = 'USER_CREATE_FAIL';
export const USER_EDIT_SUCCESS = 'USER_EDIT_SUCCESS';
export const USER_EDIT_FAIL = 'USER_EDIT_FAIL';
export const USER_ROLE_CREATE_SUCCESS = 'USER_ROLE_CREATE_SUCCESS';
export const USER_ROLE_CREATE_FAIL = 'USER_ROLE_CREATE_FAIL';
export const USER_ROLE_EDIT_SUCCESS = 'USER_ROLE_EDIT_SUCCESS';
export const USER_ROLE_EDIT_FAIL = 'USER_ROLE_EDIT_FAIL';
export const USER_GROUP_CREATE_SUCCESS = 'USER_GROUP_CREATE_SUCCESS';
export const USER_GROUP_CREATE_FAIL = 'USER_GROUP_CREATE_FAIL';
export const USER_GROUP_EDIT_SUCCESS = 'USER_GROUP_EDIT_SUCCESS';
export const USER_GROUP_EDIT_FAIL = 'USER_GROUP_EDIT_FAIL';
export const USER_RESOURCE_GROUP_CREATE_SUCCESS =
  'USER_RESOURCE_GROUP_CREATE_SUCCESS';
export const USER_RESOURCE_GROUP_CREATE_FAIL =
  'USER_RESOURCE_GROUP_CREATE_FAIL';
export const USER_RESOURCE_GROUP_EDIT_SUCCESS =
  'USER_RESOURCE_GROUP_EDIT_SUCCESS';
export const USER_RESOURCE_GROUP_EDIT_FAIL = 'USER_RESOURCE_GROUP_EDIT_FAIL';

export const GLOBAL_SEARCH_ICON_CLICK = 'GLOBAL_SEARCH_ICON_CLICK';
export const GLOBAL_SEARCH_INPUT_SEARCH = 'GLOBAL_SEARCH_INPUT_SEARCH';
export const GLOBAL_SEARCH_CLICK_RESULT = 'GLOBAL_SEARCH_CLICK_RESULT';

export const RAISE_A_TICKET_CLICK = 'RAISE_A_TICKET_CLICK';

export const GUARDRAIL_CREATE_SUCCESS = 'GUARDRAIL_POLICY_CREATE_SUCCESS';
export const GUARDRAIL_CREATE_FAIL = 'GUARDRAIL_POLICY_CREATE_FAIL';
export const GUARDRAIL_EDIT_SUCCESS = 'GUARDRAIL_POLICY_EDIT_SUCCESS';
export const GUARDRAIL_EDIT_FAIL = 'GUARDRAIL_POLICY_EDIT_FAIL';

export const CENTRAL_AUDIT_LOGS_DOWNLOAD_CLICK =
  'CENTRAL_AUDIT_LOGS_DOWNLOAD_CLICK';

export const NEW_AWS_ACCOUNT_INTEGRATION_SUCCESS =
  'NEW_AWS_ACCOUNT_INTEGRATION_SUCCESS';
export const NEW_AWS_ACCOUNT_INTEGRATION_FAIL =
  'NEW_AWS_ACCOUNT_INTEGRATION_FAIL';
export const NEW_AZURE_ACCOUNT_INTEGRATION_SUCCESS =
  'NEW_AZURE_ACCOUNT_INTEGRATION_SUCCESS';
export const NEW_AZURE_ACCOUNT_INTEGRATION_FAIL =
  'NEW_AZURE_ACCOUNT_INTEGRATION_FAIL';
export const NEW_GCP_ACCOUNT_INTEGRATION_SUCCESS =
  'NEW_GCP_ACCOUNT_INTEGRATION_SUCCESS';
export const NEW_GCP_ACCOUNT_INTEGRATION_FAIL =
  'NEW_GCP_ACCOUNT_INTEGRATION_FAIL';
export const NEW_K8S_ACCOUNT_INTEGRATION_SUCCESS =
  'NEW_K8S_ACCOUNT_INTEGRATION_SUCCESS';
export const NEW_K8S_ACCOUNT_INTEGRATION_FAIL =
  'NEW_K8S_ACCOUNT_INTEGRATION_FAIL';

export const K8S_COPILOT_ANALYSE_SUCCESS = 'K8S_COPILOT_ANALYSE_SUCCESS';
export const K8S_COPILOT_ANALYSE_FAIL = 'K8S_COPILOT_ANALYSE_FAIL';
export const K8S_COPILOT_CHAT_SUCCESS = 'K8S_COPILOT_CHAT_SUCCESS';
export const K8S_COPILOT_CHAT_FAIL = 'K8S_COPILOT_CHAT_FAIL';

export const NEW_GITHUB_ACCOUNT_INTEGRATION_SUCCESS =
  'NEW_GITHUB_ACCOUNT_INTEGRATION_SUCCESS';
export const NEW_GITHUB_ACCOUNT_INTEGRATION_FAIL =
  'NEW_GITHUB_ACCOUNT_INTEGRATION_FAIL';
export const NEW_GITLAB_ACCOUNT_INTEGRATION_SUCCESS =
  'NEW_GITLAB_ACCOUNT_INTEGRATION_SUCCESS';
export const NEW_GITLAB_ACCOUNT_INTEGRATION_FAIL =
  'NEW_GITLAB_ACCOUNT_INTEGRATION_FAIL';
export const NEW_BITBUCKET_ACCOUNT_INTEGRATION_SUCCESS =
  'NEW_BITBUCKET_ACCOUNT_INTEGRATION_SUCCESS';
export const NEW_BITBUCKET_ACCOUNT_INTEGRATION_FAIL =
  'NEW_BITBUCKET_ACCOUNT_INTEGRATION_FAIL';

export const CONTAINER_REGISTRY_CREATE_SUCCESS =
  'CONTAINER_REGISTRY_CREATE_SUCCESS';
export const CONTAINER_REGISTRY_CREATE_FAIL = 'CONTAINER_REGISTRY_CREATE_FAIL';
export const CONTAINER_REGISTRY_EDIT_SUCCESS =
  'CONTAINER_REGISTRY_EDIT_SUCCESS';
export const CONTAINER_REGISTRY_EDIT_FAIL = 'CONTAINER_REGISTRY_EDIT_FAIL';

export const OAUTH_INTEGRATION_CREATE_SUCCESS =
  'OAUTH_INTEGRATION_CREATE_SUCCESS';
export const OAUTH_INTEGRATION_CREATE_FAIL = 'OAUTH_INTEGRATION_CREATE_FAIL';
export const OAUTH_INTEGRATION_EDIT_SUCCESS = 'OAUTH_INTEGRATION_EDIT_SUCCESS';
export const OAUTH_INTEGRATION_EDIT_FAIL = 'OAUTH_INTEGRATION_EDIT_FAIL';

export const CHANNEL_CREATE_SUCCESS = 'CHANNEL_CREATE_SUCCESS';
export const CHANNEL_CREATE_FAIL = 'CHANNEL_CREATE_FAIL';
export const CHANNEL_EDIT_SUCCESS = 'CHANNEL_EDIT_SUCCESS';
export const CHANNEL_EDIT_FAIL = 'CHANNEL_EDIT_FAIL';

export const SUBSCRIPTION_CREATE_SUCCESS = 'SUBSCRIPTION_CREATE_SUCCESS';
export const SUBSCRIPTION_CREATE_FAIL = 'SUBSCRIPTION_CREATE_FAIL';
export const SUBSCRIPTION_EDIT_SUCCESS = 'SUBSCRIPTION_EDIT_SUCCESS';
export const SUBSCRIPTION_EDIT_FAIL = 'SUBSCRIPTION_EDIT_FAIL';
